import styled from "styled-components";

export const UsernameContainer = styled.div`
  position: absolute;
  top: 0;
  z-index: 15;
  width: 100%;
  height: 100vh;
  background-color: #cdcaca5a;
  backdrop-filter: blur(10px);
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const UsernameWrapper = styled.div`
  width: 30vw;
  height: auto;
  background-color: #fff;
  border-radius: 10px;
  padding: 20px;
  @media (max-width: 758px) {
    width: 80vw;
  }
`;
